module.exports = __webpack_public_path__ + "img/pocket-mobile_en.4750819.jpg";